import { HttpParameterCodec, HttpParams } from '@angular/common/http';
export class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

export function encodeParams(params: any) {
  let httpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() });
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value == null || value === '') {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item == null || item === '') {
          return;
        }
        const encodedItem =
          typeof item === 'string' ? item.trim() : String(item);
        httpParams = httpParams.append(key, encodedItem);
      });
      return;
    }
    //This will trim any leading/ending spaces on inputs
    if (typeof value === 'string') {
      httpParams = httpParams.set(key, value.trim());
      return;
    }
    httpParams = httpParams.set(key, value);
  });
  return httpParams;
}

export function removeEmptyParams(searchParams: any) {
  Object.keys(searchParams).forEach((key) => {
    if (searchParams[key] == null || searchParams[key].toString() == '') {
      delete searchParams[key];
    }
  });
  return searchParams;
}
